import { CurrencyAmount, ChainId as UniswapSDKChainId } from "@uniswap/sdk-core";
import { ETHEREUM_LOGO, ETH_LOGO, UNICHAIN_LOGO, UNICHAIN_SEPOLIA_LOGO } from "ui/src/assets";
import { USDC_UNICHAIN, USDC_UNICHAIN_SEPOLIA } from "uniswap/src/constants/tokens";
import { Chain as BackendChainId } from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { DEFAULT_NATIVE_ADDRESS_LEGACY, getQuicknodeEndpointUrl } from "uniswap/src/features/chains/evm/rpc";
import {
  NetworkLayer,
  RPCType,
  UniverseChainId
} from "uniswap/src/features/chains/types";
import { ElementName } from "uniswap/src/features/telemetry/constants";
import { unichainSepolia } from "wagmi/chains";
export const UNICHAIN_CHAIN_INFO = {
  // ...unichain, // TODO update once available from viem
  name: "Unichain",
  id: UniverseChainId.Unichain,
  sdkId: UniswapSDKChainId.UNICHAIN,
  assetRepoNetworkName: "unichain",
  backendChain: {
    chain: BackendChainId.Unichain,
    backendSupported: true,
    isSecondaryChain: false,
    nativeTokenBackendAddress: void 0
  },
  blockPerMainnetEpochForChainId: 6,
  blockWaitMsBeforeWarning: void 0,
  bridge: "https://www.unichain.org/bridge",
  docs: "https://docs.unichain.org",
  elementName: ElementName.ChainUnichain,
  explorer: {
    name: "Unichain Explorer",
    url: "https://uniscan.xyz/"
  },
  helpCenterUrl: void 0,
  infoLink: "https://app.uniswap.org/explore/tokens/unichain",
  infuraPrefix: "unichain",
  interfaceName: "unichain",
  label: "Unichain",
  logo: UNICHAIN_LOGO,
  nativeCurrency: {
    name: "Unichain ETH",
    symbol: "ETH",
    decimals: 18,
    address: DEFAULT_NATIVE_ADDRESS_LEGACY,
    logo: ETHEREUM_LOGO
  },
  networkLayer: NetworkLayer.L2,
  pendingTransactionsRetryOptions: void 0,
  rpcUrls: {
    [RPCType.Public]: { http: [getQuicknodeEndpointUrl(UniverseChainId.Unichain)] },
    [RPCType.Default]: { http: ["https://mainnet.unichain.org"] },
    [RPCType.Interface]: { http: [getQuicknodeEndpointUrl(UniverseChainId.Unichain)] }
  },
  spotPriceStablecoinAmount: CurrencyAmount.fromRawAmount(USDC_UNICHAIN, 1e10),
  stablecoins: [USDC_UNICHAIN],
  statusPage: void 0,
  supportsInterfaceClientSideRouting: true,
  supportsGasEstimates: true,
  supportsV4: true,
  urlParam: "unichain",
  wrappedNativeCurrency: {
    name: "Wrapped Ether",
    symbol: "WETH",
    decimals: 18,
    address: "0x4200000000000000000000000000000000000006"
  },
  testnet: false
};
export const UNICHAIN_SEPOLIA_CHAIN_INFO = {
  ...unichainSepolia,
  name: "Unichain Sepolia",
  testnet: true,
  id: UniverseChainId.UnichainSepolia,
  sdkId: UniswapSDKChainId.UNICHAIN_SEPOLIA,
  assetRepoNetworkName: void 0,
  backendChain: {
    chain: BackendChainId.AstrochainSepolia,
    backendSupported: true,
    isSecondaryChain: false,
    nativeTokenBackendAddress: void 0
  },
  blockPerMainnetEpochForChainId: 1,
  blockWaitMsBeforeWarning: void 0,
  bridge: void 0,
  docs: "https://docs.unichain.org/",
  elementName: ElementName.ChainUnichainSepolia,
  explorer: {
    name: "Unichain Sepolia Explorer",
    url: "https://unichain-sepolia.blockscout.com/"
  },
  helpCenterUrl: void 0,
  infoLink: "https://app.uniswap.org/explore",
  // need
  infuraPrefix: "astrochain-sepolia",
  interfaceName: "astrochain",
  label: "Unichain Sepolia",
  logo: UNICHAIN_SEPOLIA_LOGO,
  nativeCurrency: {
    name: "Unichain Sepolia ETH",
    symbol: "ETH",
    decimals: 18,
    address: DEFAULT_NATIVE_ADDRESS_LEGACY,
    logo: ETH_LOGO
  },
  networkLayer: NetworkLayer.L2,
  pendingTransactionsRetryOptions: void 0,
  rpcUrls: {
    [RPCType.Public]: {
      http: [getQuicknodeEndpointUrl(UniverseChainId.UnichainSepolia)]
    },
    [RPCType.Default]: {
      http: [getQuicknodeEndpointUrl(UniverseChainId.UnichainSepolia)]
    },
    [RPCType.Interface]: {
      http: [getQuicknodeEndpointUrl(UniverseChainId.UnichainSepolia)]
    }
  },
  spotPriceStablecoinAmount: CurrencyAmount.fromRawAmount(USDC_UNICHAIN_SEPOLIA, 1e10),
  stablecoins: [USDC_UNICHAIN_SEPOLIA],
  statusPage: void 0,
  supportsInterfaceClientSideRouting: true,
  supportsGasEstimates: false,
  supportsV4: true,
  urlParam: "unichain_sepolia",
  wrappedNativeCurrency: {
    name: "Wrapped Ether",
    symbol: "WETH",
    decimals: 18,
    address: "0x4200000000000000000000000000000000000006"
  }
};
